import { get_image_url_for_user } from "./api";
import { useApiState } from "#hooks";
import { InputGroup } from "#common";
import { cn } from "#utils";
import { useState } from "react";

function FosterInformation() {
  const { state, onChange, isChanged, submit, reset } = useApiState(
    "/fosterhome/me",
    "/fosterhome/me",
  );
  const [isDisabled, setIsDisabled] = useState(false);
  const handleSaveChanges = async () => {
    setIsDisabled(true);
    await submit();
    setIsDisabled(false);
  };
  return (
    <div className="divide-y divide-gray-200 dark:divide-white/10">
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base/7 font-semibold text-gray-900 dark:text-white">
            Personal Information
          </h2>
          <p className="mt-1 text-sm/6 text-gray-500 dark:text-gray-400">
            Use a permanent address where you can receive mail.
          </p>
        </div>
        {state && (
          <div className="md:col-span-2">
            <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
              <div className="col-span-full">
                <InputGroup
                  label="Username"
                  name="username"
                  value={state.username}
                  onChange={onChange}
                />
              </div>
              <div className="col-span-full flex items-center gap-x-8">
                <img
                  alt=""
                  src={get_image_url_for_user(state.userId)}
                  className="size-24 flex-none rounded-lg bg-gray-100 object-cover outline -outline-offset-1 outline-black/5 dark:bg-gray-800 dark:outline-white/10"
                />
                <div>
                  <button
                    type="button"
                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-100 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20"
                  >
                    Change avatar
                  </button>
                  <p className="mt-2 text-xs/5 text-gray-500 dark:text-gray-400">
                    JPG, GIF or PNG. 1MB max.
                  </p>
                </div>
              </div>

              <div className="sm:col-span-3">
                <InputGroup
                  label="First Name"
                  name="firstName"
                  value={state.firstName}
                  onChange={onChange}
                />
              </div>

              <div className="sm:col-span-3">
                <InputGroup
                  label="Last Name"
                  name="lastName"
                  value={state.lastName}
                  onChange={onChange}
                />
              </div>

              <div className="col-span-full">
                <InputGroup
                  label="Email"
                  name="email"
                  value={state.email}
                  onChange={onChange}
                />
              </div>

              <div className="col-span-full">
                <InputGroup
                  label="Phone Number"
                  name="phone"
                  value={state.phone}
                  onChange={onChange}
                />
              </div>
            </div>
            {isChanged && (
              <div className="mt-8 flex gap-2">
                <button
                  type="button"
                  onClick={reset}
                  className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-red-500 dark:shadow-none dark:hover:bg-red-400 dark:focus-visible:outline-red-500"
                >
                  Discard
                </button>
                <button
                  type="button"
                  onClick={handleSaveChanges}
                  disabled={isDisabled}
                  className={cn(
                    "rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500",
                    "flex gap-2 items-center",
                  )}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default FosterInformation;
